<!--
* 组件名 : 侧滑导航-背景图组件
* 开发者 : HN
*
* 参数:  无
*
* 事件:  null
*
-->
<template>
  <ul class="menu-bgs">
    <li
      v-for="(item, i) in menuBg"
      :key="i"
      :class="['menu-bg', isActiveMenuBg === i ? 'show' : '']"
      v-bg-img="item"
    ></li>
  </ul>
</template>

<script>
export default {
  name: "menu-bgs",
  props: {
    isActiveMenuBg: {
      type: Number,
    },
  },
  data() {
    return {
      menuBg: [
        "images/menu-bg/menu-bg-1.jpg",
        "images/menu-bg/menu-bg-2.jpg",
        "images/menu-bg/menu-bg-3.jpg",
        "images/menu-bg/menu-bg-4.jpg",
        "images/menu-bg/menu-bg-5.jpg",
        "images/menu-bg/menu-bg-6.jpg",
        // "images/menu-bg/menu-bg-7.jpg",
        "images/menu-bg/menu-bg-8.jpg",
        "images/menu-bg/menu-bg-9.jpg",
        "images/menu-bg/menu-bg-10.jpg",
      ],
    };
  },
};
</script>

<style lang="scss">
#menu {
  .menu-container {
    .menu-bgs {
      position: absolute;
      z-index: -1;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      transition: all $base-duration cubic-bezier(0.645, 0.045, 0.355, 1);
      transition-delay: 250ms;
      opacity: 0;
      li {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transition: opacity 2s cubic-bezier(0.165, 0.84, 0.44, 1) 0.2s;
        opacity: 0;
        background-size: cover;
        &.show {
          opacity: 1;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>